
import {initWebComponent} from "@/helpers/web-component-helper";
import {WizardComponent} from "@/components/wizard/wizard-component";
import {WizardNavItemComponent} from "@/components/wizard/wizard-nav-item-component";

const template = document.createElement('template');

export class WizardNavComponent extends HTMLElement {
    constructor() {
        super();

        let innerHtml = `<ul class="nav nav-progress">`

        window.wizard.Items.map( (item, key) => {
            innerHtml += `<wizard-nav-item data-name="` + item.Name + `" data-key="` + key + `"></wizard-nav-item>`
        })

        innerHtml += `</ul>`;

        template.innerHTML = innerHtml

        initWebComponent(this, template)
    }
}

window.customElements.define("wizard-nav-item", WizardNavItemComponent);
